import SharedTransitionLevelData from '@/shared/models/TransitionLevelData'

export default class TransitionLevelData extends SharedTransitionLevelData {

}